import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Typography,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { setCourseRecommendation } from '../../../redux/actions/WizardLaunchActions';

import './CourseRecommendation.scss';

function CourseRecommendation({ setFormState }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const courseRecommendationData = useSelector(
    (state) => state.wizardLaunch.courseRecommendation
  );
  const dynamicData = useSelector(
    (state) => state.wizardLaunch.screenData.recommend
  );
  const isLoading = useSelector(
    (state) => state.wizardLaunch.dynamicDataLoading
  );
  const error = useSelector((state) => state.wizardLaunch.dynamicDataError);
  const [selectedValue, setSelectedValue] = useState(null);

  const handleButtonClick = (option) => {
    if (option.answer.title?.toLowerCase()?.includes('instructor-led theory')) {
      navigate('/contact');
    } else {
      setSelectedValue(option.answer.id);
      dispatch(
        setCourseRecommendation({
          id: option.answer.id,
          answer: option.answer,
          next_question_id: option.next_question_id,
          question_answer_id: option.question_answer_id,
        })
      );

      setFormState({
        question_id: option.next_question_id,
        userAnswer: {
          question_answer_id: option.answer.question_answer_id,
          answer: option.answer.answer,
          next_question_id: option.answer.next_question_id,
        },
        question_type: 'recommend',
      });
    }
  };

  if (isLoading) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        minHeight='200px'
      >
        <Typography color='error'>
          Error loading recommendations. Please try again later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      className='course-recomment-wrap'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '800px',
        margin: '0 auto',
        textAlign: 'center',
      }}
    >
      <Typography
        variant='h5'
        gutterBottom
        sx={{
          color: '#0A2647',
          mb: 4,
        }}
      >
        {dynamicData?.question_text || 'Recommended Courses'}
      </Typography>

      <Box sx={{ width: '100%' }}>
        {dynamicData?.options?.map((courseList, index) => {
          // console.log(courseList);
          return (
            <div key={index} className='cards'>
              <div className='left-sec'>
                <Typography variant='h4'>
                  {courseList?.answer?.title}
                </Typography>
                <Typography>{courseList?.answer?.description}</Typography>
                <Typography variant='h6'>
                  {courseList?.answer?.subtitle}
                </Typography>
                <ul>
                  {courseList?.answer?.buttonlabel === 'Contact Admissions' ? (
                    <>
                      <li>
                        Individuals who can commit to a 4 hour a day online
                        class.
                      </li>
                      <li>

                        Individuals who learn better from an instructor teaching them.
                      </li>
                    </>
                  ) : (
                    <>
                      <li>
                        You cannot attend live virtual sessions due to your
                        schedule.
                      </li>
                      <li>
                        You have successfully performed other online training.
                      </li>
                    </>
                  )}
                </ul>
              </div>
              <div className='right-sec'>
                <Typography variant='h2'>
                  {' '}
                  {courseList?.answer?.price}
                </Typography>
                <Button
                  variant='contained'
                  onClick={() => handleButtonClick(courseList)}
                  sx={{
                    textTransform: 'none'
                  }}
                >
                  {courseList?.answer?.buttonlabel}
                </Button>
                {/* {courseList?.answer?.buttonlabel === "Buy Now" && (
                  <Typography>
                    *This program is not yet approved by the Colorado Private
                    Occupational School Board
                  </Typography>
                )} */}
              </div>
            </div>
          );
        })}
      </Box>

    </Box>
  );
}

export default CourseRecommendation;